import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { IconButton, Grid, Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, AppBar, Tabs, Tab, Typography } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import moment from 'moment-timezone'
import { withTranslation } from "react-i18next";
import getConsultationStatusByLang from '../../common/consultationStatusByLang';
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import SearchableMultiSelect from '../../common/SearchableMultiSelect';
import { toast } from 'react-toastify';
import { ConsultationDetails } from "./details";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI } from "../../../utils/datetime.utils";

function getReportTimezone() {
  const stored = sessionStorage.getItem('timeZone');
  if (stored) return stored.substring(stored.lastIndexOf(' ') + 1);
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      order,
      orderBy,
      sortId,
      t
    } = this.props;
    const rows = [
      { id: "username", numeric: false, disablePadding: false, label: t("Report.Consult.Patient"), padding: '8px', field: 'user_name' },
      { id: "consultationname", numeric: false, disablePadding: false, label: t("Report.Consult.Pharmacist"), padding: '8px', field: 'consultation_name' },
      { id: "store", numeric: false, disablePadding: false, label: t("Report.Consult.Store"), padding: '8px', field: 'store_name' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.Consult.Box"), padding: '8px', field: 'kiosk_name' },
      { id: "date", numeric: false, disablePadding: false, label: t("Report.Consult.Date"), padding: '8px', field: 'date' },
      { id: "consultstartdate", numeric: false, disablePadding: false, label: t("Report.Consult.StartTime"), padding: '8px', field: 'consult_start_date' },
      { id: "consultenddate", numeric: false, disablePadding: false, label: t("Report.Consult.EndTime"), padding: '8px', field: 'consult_end_date' },
      { id: "callduration", numeric: false, disablePadding: false, label: t("Report.Consult.CallDuration"), padding: '8px', field: 'call_duration' },
      { id: "pickupcode", numeric: false, disablePadding: false, label: t("Report.Consult.PUCode"), padding: '8px', field: 'pickup_code' },
      { id: "Status", numeric: false, disablePadding: false, label: t("Report.Consult.Status"), padding: '8px', field: 'Status' },
      { id: "consultationnotes", numeric: false, disablePadding: false, label: t("Report.Consult.ConsultationNotes"), padding: '8px', field: 'consultation_notes' },
      { id: "isorderrelease", numeric: false, disablePadding: false, label: t("Report.Consult.OrderRelease"), padding: '8px', field: 'is_releaseorder' },
      { id: "reject_reason", numeric: false, disablePadding: false, label: t("Report.Consult.RejectReason"), padding: '8px', field: 'reject_reason' },
      { id: "id_capture_type", numeric: false, disablePadding: false, label: t("Report.Consult.IDCaptureType"), padding: '8px', field: 'id_capture_type' },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'grey' }}
              >
                {['callduration'].includes(row.id) ?
                  (<TableSortLabel style={{ cursor: 'text' }}>
                    {row.label}
                  </TableSortLabel>
                  ) : (
                    <Tooltip
                      title={t("Global.Label.Filter.Sort")}
                      placement={row.numeric ? "bottom-end" : "bottom-start"}
                      enterDelay={300}
                    >
                      <TableSortLabel
                        active={orderBy === row.field && sortId === row.id}
                        direction={order}
                        onClick={this.createSortHandler(row.id, row.field)}
                      >
                        {row.label}
                      </TableSortLabel>
                    </Tooltip>
                  )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);


const styles = theme => ({
  root: {
    width: "100%",
    // marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  },
  padding10px: {
    padding: '8px'
  }
  ,
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  }

});

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: '',
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: '',
  group_id: null,
  timezone: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      dob: '',
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      isDataEmpty: true,
      totalRecords: 0,
      isButtonDisabled: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      printDialogOpen: false,
      details: null,
      queryId: "",
      groups: [],
      selectedTab: 0,
      pickupOrders: [],
      pickupOrdersLoading: false,
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleBoxChange = this.handleBoxChange.bind(this);
    this.debouceTimeout = null;
  }

  componentDidMount() {
    TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
    // Get user's timezone for date filtering in CSV/ConsultReport service
    let userTimeZone = sessionStorage.getItem('timeZone');
    if (['null', null, 'undefined', undefined, ''].includes(userTimeZone)) {
      userTimeZone = defaultZone;
    }
    TransactionFilterObj.timezone = userTimeZone.substring(userTimeZone.lastIndexOf(' ') + 1);
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const { t } = this.props;
        let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });

        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.setState({ loader: false });
      });
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({ 
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });

    TransactionFilterObj = {
      store_ids: [],
      box_ids: [],
      searchtext: '',
      fromdate: formatFromDateForAPI(defaultDates.fromDate),
      todate: formatToDateForAPI(defaultDates.toDate),
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'created_on',
      tableName: '',
      timezone: TransactionFilterObj.timezone
    }
    this.fetchSuggestions()
    this.BindGrid();
  }

  convertToTimeZone = (requestDate, timeOnly = false) => {
    if (!requestDate) return '';
    
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone, format = '';
    zone = sessionStorage.getItem('timeZone');
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    } 
    let zoneName = zone.substring(zone.lastIndexOf(' ') + 1);
    
    if(currentUserLang === 'en'){
      format = 'MM/DD/YYYY hh:mm:ss A';
    }else{
      format = 'DD/MM/YYYY hh:mm:ss A';
    }
    
    if(timeOnly){
      format = 'hh:mm:ss A';
      // Check if the input is time-only (doesn't contain date part)
      if (!requestDate.includes('/') && !requestDate.includes('-')) {
        const currentDate = moment();
        requestDate = currentDate.format('YYYY-MM-DD ') + requestDate;
      }
    }
    
    const date = moment.parseZone(requestDate);
    return date.isValid() ? date.tz(zoneName).format(format) : '';
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/ConsultReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...TransactionFilterObj,
        timezone: getReportTimezone()
      })
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        const { t } = this.props;
        let csvRow = [];
        let Array = [['Id', 'Patient', 'Pharmacist', 'Store', 'Box', 'Date', 'Start Time', 'End Time', 'Call Duration', 'P/U Code', 'Status', 'Consultation Notes', 'Order Release']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Array.push(
                [
                  i.username,
                  i.consultationname,
                  i.store,
                  i.box,
                  i.date ? this.convertToTimeZone(i && i.date) : '',
                  i.consultstartdate ? this.convertToTimeZone(i && i.consultstartdate, true) : '',
                  i.consultenddate ? this.convertToTimeZone(i && i.consultenddate, true) : '',
                  i.callduration,
                  i.pickupcode,
                  getConsultationStatusByLang(i.Status, t),
                  (i.consultationnotes === "" || i.consultationnotes === null || i.consultationnotes === undefined) ? "" : i.consultationnotes.replaceAll(',', ' ').trim(),
                  i.isorderrelease === false ? t("Global.Consultation.Action.No") : t("Global.Consultation.Action.Yes")
                ]
              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "ConsultReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
      });
  }

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['username', 'consultationname', 'box', 'date', 'consultstartdate', 'consultenddate', 'pickupcode', 'Status', 'consultationnotes', 'isorderrelease'].includes(field)) {
      tablename = 'user_consult_master';
    }
    if (['store'].includes(field)) {
      tablename = 'accounts';
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    TransactionFilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {
    const { data } = this.state;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const { t } = this.props;
          let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          this.setState({ chipboxes: [] });
          this.setState({ nboxes: [] });
          this.setState({ boxvalues: boxvalues });
          this.setState({ loader: false });
        });


    }

  }
  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.accountValues[0]];
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (storeid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindBoxesbyStoreId(storeids);
    this.BindGrid();
  };
  handleBoxChange = event => {
    const boxid = event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.boxvalues[0]];
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if (boxid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (boxid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          boxids.push(processed[i].id)
        }
      }
    }

    this.setState({ box_id: boxids });
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindBoxesbyStoreId([]);
      this.BindGrid();
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleDeleteBoxChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipboxes: [], nboxes: [], box_id: [] });
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindGrid();
      return;
    }
    const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
    const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
    this.setState({ chipboxes: updatedBoxes, nboxes: updatedNBoxes });
    const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindBoxesbyStoreId([]);
    this.BindGrid();
  };

  handleClearAllBoxes = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipboxes: [], nboxes: [], box_id: [] });
    TransactionFilterObj.box_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  }
  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };
  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
    this.setState({ loader: true })
  }
  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
    this.setState({ loader: true })
  }
  
  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };


  BindGrid() {
    this.setState({ loader: true, data: null });
    fetch(process.env.REACT_APP_BASEURL + 'getConsultReport', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...TransactionFilterObj,
        timezone: getReportTimezone()
      })

    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        if (uData && uData.results && uData.results.length > 0) {
          this.setState({ data: uData.results, totalRecords: uData && uData.total });
          setTimeout(() => {
            this.setState({ loader: uData && uData.total && false, isDataEmpty: false, isButtonDisabled: false });
          }, 5000)
        }
        else {
          this.setState({ data: null, loader: false, isDataEmpty: true, isButtonDisabled: true });
        }
      });
  }

  handlePUcodeClick = (e, pickupCode, userConsultMasterId) => {
    e && e.preventDefault();
    this.setState({
      loader: true,
      selectedTab: 0,
      pickupOrders: [],
      pickupOrdersLoading: true,
    });
    fetch(`${process.env.REACT_APP_BASEURL}consultation?code=${pickupCode}&id=${userConsultMasterId}`, {
      method: "GET",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      }
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((consultationDetails) => {
        const detailsData = consultationDetails && consultationDetails.data;
        const firstRow = detailsData && detailsData[0];
        this.setState({
          loader: false,
          printDialogOpen: true,
          details: detailsData
        });
        this.fetchPickupOrdersForConsultation(pickupCode, firstRow);
      }).catch((error) => {
        toast.error(error && error.message);
        this.setState({ loader: false, pickupOrdersLoading: false });
      });
  };

  handlePopupClose = () => {
    this.setState({ printDialogOpen: false, selectedTab: 0, pickupOrders: [], pickupOrdersLoading: false });
  }

  getIDCaptureType = (type) => {
    const { t } = this.props;
    let typeString = "";
    switch (type) {
      case 0:
        typeString = t("Report.Consult.IsAccepted");
        break;
      case 1:
        typeString = t("Report.Consult.IsRejected");
        break;
      default:
        typeString = "N/A"
        break;
    }
    return typeString;
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    TransactionFilterObj.group_id = event.target.value
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };
  fetchPickupOrdersForConsultation = (pickupCode, consultationRow) => {
    const userSession = sessionStorage.getItem('user');
    if (!userSession) {
      this.setState({ pickupOrders: [], pickupOrdersLoading: false });
      return;
    }

    const authToken = JSON.parse(userSession).signInUserSession.idToken.jwtToken;

    const headers = {
      'Authorization': 'Bearer ' + authToken,
      'Content-Type': 'application/json'
    };

    const finalizeWithCodes = (codes) => {
      const uniqueCodes = Array.from(new Set((codes || []).filter(Boolean)));
      const effectiveCodes = uniqueCodes.length > 0 ? uniqueCodes : (pickupCode ? [pickupCode] : []);

      if (effectiveCodes.length === 0) {
        this.setState({ pickupOrders: [], pickupOrdersLoading: false });
        return;
      }

      fetch(process.env.REACT_APP_BASEURL + 'getprescriptiondetailbypucode', {
        method: 'POST',
        withCredentials: true,
        headers,
        body: JSON.stringify({ ordersPickUpCode: effectiveCodes })
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          if (Array.isArray(data) && data.length > 0) {
            this.setState({
              pickupOrders: data,
              pickupOrdersLoading: false
            });
          } else {
            this.setState({
              pickupOrders: [],
              pickupOrdersLoading: false
            });
          }
        })
        .catch((error) => {
          this.setState({
            pickupOrders: [],
            pickupOrdersLoading: false
          });
        });
    };

    // Use existing getPrescriptionDetailsByAccountId endpoint so we don't need
    // any new APIs or DB changes. This endpoint already knows how to look up
    // a consultation notification and all of its pickup codes.
    const accountId = consultationRow && consultationRow.accounts_id;

    if (!accountId) {
      // If for some reason we don't have an account id, fall back to the
      // original single-code behaviour.
      finalizeWithCodes(pickupCode ? [pickupCode] : []);
      return;
    }

    const payload = {
      account_id: accountId,
      page: 1,
      limit: 50,
      // Search by the primary pickup code that the report row is based on.
      search: pickupCode || ''
    };

    fetch(process.env.REACT_APP_BASEURL + 'getPrescriptionDetailsByAccountId', {
      method: 'POST',
      withCredentials: true,
      headers,
      body: JSON.stringify(payload)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(result => {
        const notificationDetails = result
          && result.data
          && Array.isArray(result.data.notification_details)
          ? result.data.notification_details
          : [];

        if (!notificationDetails || notificationDetails.length === 0) {
          // Nothing found via notifications – fall back to single pickup code.
          finalizeWithCodes(pickupCode ? [pickupCode] : []);
          return;
        }

        // Find the notification whose prescription_details contain our pickupCode.
        let matchedNotification = null;

        if (pickupCode) {
          matchedNotification = notificationDetails.find(n =>
            Array.isArray(n.prescription_details) &&
            n.prescription_details.some(p =>
              p.pickup_code === pickupCode || p.pucode === pickupCode
            )
          );
        }

        // If we didn't find an exact match, just take the first notification.
        if (!matchedNotification) {
          matchedNotification = notificationDetails[0];
        }

        const orders = matchedNotification && Array.isArray(matchedNotification.prescription_details)
          ? matchedNotification.prescription_details
          : [];

        if (orders.length > 0) {
          this.setState({
            pickupOrders: orders,
            pickupOrdersLoading: false
          });
        } else {
          // As a last resort, fall back to single pickup code.
          finalizeWithCodes(pickupCode ? [pickupCode] : []);
        }
      })
      .catch((error) => {
        // On any error, fall back to the original single-code behaviour.
        finalizeWithCodes(pickupCode ? [pickupCode] : []);
      });
  };

  handleTabChange = (event, newValue) => {
    this.setState({ selectedTab: newValue });
  };

  render() {
    const { classes, t } = this.props;
    const { data, totalRecords, locale, details, queryId, groups, selectedTab, pickupOrders, pickupOrdersLoading } = this.state;
    return (
      <div className={classes.root}>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }

        <Box component="div">
          <Grid container spacing={4} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
            <Grid item xs={3} md={3} style={{ paddingLeft: 0 }}>
              <SearchableMultiSelect
                label={t("Report.Consult.Store")}
                items={this.state.accountValues || []}
                selectedChips={this.state.chipstores}
                selectedItems={this.state.nstores}
                onChange={this.handleStoreChange}
                onDeleteChip={this.handleDeleteStoreChip}
                onClearAll={this.handleClearAllStores}
                placeholder="Search stores..."
                id="select-multiple-chip-store"
              />
            </Grid>
            <Grid item xs={3} md={3}>
              <SearchableMultiSelect
                label={t("Report.Consult.Box")}
                items={this.state.boxvalues || []}
                selectedChips={this.state.chipboxes}
                selectedItems={this.state.nboxes}
                onChange={this.handleBoxChange}
                onDeleteChip={this.handleDeleteBoxChip}
                onClearAll={this.handleClearAllBoxes}
                placeholder="Search locations..."
                id="select-multiple-chip"
              />
            </Grid>
            <Grid item xs={2} md={2}>
              <FormControl sx={{ width: '100%' }}>
                <InputLabel variant="standard">{t("Global.Label.DropDown.DateRange") || "Date Range"}</InputLabel>
                <Select
                  value={this.state.dateRangePreset}
                  onChange={this.handleDateRangePresetChange}
                  variant="standard"
                  label={t("Global.Label.DropDown.DateRange") || "Date Range"}
                >
                  <MenuItem value="today">{t("Global.Label.DropDown.Today") || "Today"}</MenuItem>
                  <MenuItem value="last7days">{t("Global.Label.DropDown.Last7Days") || "Last 7 days"}</MenuItem>
                  <MenuItem value="last15days">{t("Global.Label.DropDown.Last15Days") || "Last 15 days"}</MenuItem>
                  <MenuItem value="last30days">{t("Global.Label.DropDown.Last30Days") || "Last 30 days"}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2} md={2}>
              <FormControl sx={{ width: '100%' }}>
                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                  <DesktopDatePicker
                    disableFuture
                    keyboard
                    value={this.state.fromdate}
                    renderInput={(params) =>
                      <TextField
                        {...params}
                        label={t("Report.Consult.ConsultStartDate")}
                        variant="standard"
                        allowKeyboardControl={true}
                        onBlur={this.handleBlurfrom}
                      />
                    }
                    onChange={this.onFromDateSelect}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={2} md={2}>
              <FormControl sx={{ width: '100%' }}>
                <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                  <DesktopDatePicker
                    disableFuture
                    keyboard
                    value={this.state.todate}
                    renderInput={(params) =>
                      <TextField
                        {...params}
                        label={t("Report.Consult.ConsultEndDate")}
                        variant="standard"
                        allowKeyboardControl={true}
                        onBlur={this.handleBlurtodate}
                      />
                    }
                    onChange={this.onToDateSelect}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={0} sx={{ mt: '1rem', ml: 0, width: '100%', p: '0% 2% 1%' }}>
            <Grid item xs={3} md={3}>
              <FormControl fullWidth>
                <TextField
                  id="idsearchtxt"
                  defaultValue=""
                  value={this.state.searchtxt}
                  label={t("Report.Consult.Search")}
                  onChange={this.onSearchChange}
                  variant="standard"
                />
              </FormControl>
            </Grid>
            <Grid item xs={3} md={3} style={{ paddingLeft: '32px' }}>
              <FormControl
                variant='standard'
                sx={{ m: '16px 0', minWidth: 347 }}
              >
                <InputLabel id='preferred-group-label'>
                  {t('Group.User.GroupControlTitle')}
                </InputLabel>
                <Select
                  labelId='preferred-group-label'
                  id='preferred-group-select-standard'
                  value={queryId}
                  onChange={this.handleInputChange}
                  variant='standard'
                  label={t('Group.User.GroupControlTitle')}
                >
                  {groups.length > 0 &&
                    groups.map((type, index) => (
                      <MenuItem
                        key={index}
                        value={type.id}
                        className={classes.locationType}
                      >
                        {type.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} md={3}>
              <FormControl fullWidth>
              </FormControl>
            </Grid>
            <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
              <Tooltip key="single-edit" title={t("Report.Consult.ExportCSVTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportCSV"
                  onClick={() => { this.exportCSV() }}
                  disabled={this.state.isButtonDisabled}
                >
                  <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
        <Divider style={{ marginTop: '10px', height: '5px' }} />

        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              order={TransactionFilterObj.sortOrder}
              orderBy={TransactionFilterObj.sortColumn}
              sortId={this.state.sortId}
              onRequestSort={this.handleRequestSort}
            />
            <TableBody>
              {!data ?
                (<TableRow>
                  <TableCell colSpan={14} style={{ textAlign: "center", padding: '10px 0px' }}>
                    {this.state.isDataEmpty && t("Report.Consult.NoDataFound")}
                  </TableCell>
                </TableRow>)
                :
                data.length && data.length > 0 &&
                stableSort(data, getSorting(TransactionFilterObj.sortOrder, TransactionFilterObj.sortColumn))
                  .map(n => {
                    return (
                      <TableRow>
                        <TableCell className={classes.padding10px}>{n.username}</TableCell>
                        <TableCell className={classes.padding10px}>{n.consultationname}</TableCell>
                        <TableCell className={classes.padding10px}>{n.store}</TableCell>
                        <TableCell className={classes.padding10px}>{n.box}</TableCell>
                        <TableCell className={classes.padding10px}>{n.date ? this.convertToTimeZone(n && n.date) : ''}</TableCell>
                        <TableCell className={classes.padding10px}>{n.consultstartdate ? this.convertToTimeZone(n && n.consultstartdate, true) : ''}</TableCell>
                        <TableCell className={classes.padding10px}>{n.consultenddate ? this.convertToTimeZone(n && n.consultenddate, true) : ''}</TableCell>
                        <TableCell className={classes.padding10px}>{n.callduration}</TableCell>
                        <TableCell className={classes.padding10px}><a href='' title="View consultation by" style={{ color: '#385cad', fontWeight: 500, textDecoration: 'none ', fontSize: '1rem' }} onClick={(event) => this.handlePUcodeClick(event, n.pickupcode, n.user_consult_master_id)}> {n.pickupcode}</a></TableCell>
                        <TableCell className={classes.padding10px}>{getConsultationStatusByLang(n.Status, t)}</TableCell>
                        <TableCell className={classes.padding10px}>{n.consultationnotes}</TableCell>
                        <TableCell className={classes.padding10px}>{n.isorderrelease === false ? t("Global.Consultation.Action.No") : t("Global.Consultation.Action.Yes")}</TableCell>
                        <TableCell className={classes.padding10px}>{[undefined, 'undefined', null, 'null', ""].includes(n.reject_reason) ? "" : n.reject_reason}</TableCell>
                        <TableCell className={classes.padding10px}>{this.getIDCaptureType(n && n.id_capture_type)}</TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </div>
        <Dialog
          open={this.state.printDialogOpen || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          PaperProps={{
            // Increase width by ~30% (700px → ~910px)
            style: { maxWidth: '50%', maxHeight: '100%' }
          }}
        >
          <DialogTitle id="alert-dialog-title">{t("Report.Consult.ConsultationSummaryTitle")}</DialogTitle>
          <AppBar position="static" color="default">
            <Tabs
              value={selectedTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label={t("Report.Consult.SummaryTab") || "Consultation Summary"} />
              <Tab label={t("Report.Consult.OrdersTab") || "Related Orders"} />
            </Tabs>
          </AppBar>
          <DialogContent>
            {selectedTab === 0 && details && (
              <ConsultationDetails details={details} pickupOrders={pickupOrders} t={t} />
            )}
            {selectedTab === 1 && (
              <Box style={{ maxHeight: '500px', overflow: 'auto' }}>
                {pickupOrdersLoading && (
                  <Box sx={{ textAlign: 'center', p: 2 }}>
                    {t("Report.Consult.LoadingRelatedOrders") || "Loading related orders..."}
                  </Box>
                )}
                {!pickupOrdersLoading && (!pickupOrders || pickupOrders.length === 0) && (
                  <Box sx={{ textAlign: 'center', p: 2 }}>
                    {t("Report.Picked.NoDataFound")}
                  </Box>
                )}
                {!pickupOrdersLoading && pickupOrders && pickupOrders.length > 0 && (
                  <div>
                    {Array.isArray(pickupOrders) &&
                      pickupOrders.some(order =>
                        [true, 'true', 1, '1'].includes(order && order.is_controlled_substance)
                      ) && (
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Box
                            sx={{
                              width: 12,
                              height: 12,
                              bgcolor: '#FFF7ED',
                              border: '1px solid #FDBA74',
                              mr: 0.75,
                            }}
                          />
                          <Typography variant="body2" color="textSecondary">
                            {t("Home.StartConsultPopup.ControlledSubstanceLegend")}
                          </Typography>
                        </Box>
                      )}
                    <Table size="small" aria-label="related orders table">
                      <TableHead>
                        <TableRow>
                          <TableCell>{t("Report.Assign.StockCode")}</TableCell>
                          <TableCell>{t("Console.ActionPopup.PickupCode")}</TableCell>
                          <TableCell>{t("Report.Picked.RxHash")}</TableCell>
                          <TableCell>{t("Report.Picked.FillID")}</TableCell>
                          <TableCell>{t("Report.Picked.DrugName")}</TableCell>
                          <TableCell>{t("Report.Picked.Qty")}</TableCell>
                          <TableCell>{t("Report.Picked.AmountDue")}</TableCell>
                          <TableCell>{t("Report.Picked.PickupDate")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {pickupOrders.map(order => (
                          (() => {
                            const isControlled =
                              order &&
                              ([true, 'true', 1, '1'].includes(order.is_controlled_substance));
                            return (
                              <TableRow
                                key={
                                  (order.rx_no && order.fillnumber && `${order.rx_no}-${order.fillnumber}`)
                                  || order.pucode
                                  || Math.random()
                                }
                                style={isControlled ? { backgroundColor: '#FFF7ED' } : undefined}
                                title={isControlled ? t("Home.StartConsultPopup.ControlledSubstanceLegend") : undefined}
                              >
                                <TableCell>{order.stock_code || ''}</TableCell>
                                <TableCell>{order.pickup_code || order.pucode || ''}</TableCell>
                                <TableCell>{order.rx_no}</TableCell>
                                <TableCell>{order.fillnumber}</TableCell>
                                <TableCell>{order.drug_name}</TableCell>
                                <TableCell>{order.qty}</TableCell>
                                <TableCell>{order.price ? '$' + parseFloat(order.price).toFixed(2) : '$0.00'}</TableCell>
                                <TableCell>{order.stocked_date ? this.convertToTimeZone(order.stocked_date) : ''}</TableCell>
                              </TableRow>
                            );
                          })()
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(event) => this.handlePopupClose(event)}
              color='primary'
            >
              {t('Home.UserPopup.Close')}
            </Button>
          </DialogActions>
        </Dialog>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            component="div"
            rowsPerPageOptions={[5, 10, 25]}
            count={totalRecords || 0}
            rowsPerPage={TransactionFilterObj.pageSize}
            page={TransactionFilterObj.pageNo}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/consultation/index.js